import { render, staticRenderFns } from "./EditCustomerForm.vue?vue&type=template&id=3b107bc1&scoped=true&"
import script from "./EditCustomerForm.vue?vue&type=script&lang=js&"
export * from "./EditCustomerForm.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomerForm.vue?vue&type=style&index=0&id=3b107bc1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b107bc1",
  null
  
)

export default component.exports